import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { Header, Button } from "../../components/RegularComponents";
import TopNavigationBar from "../TopNavigationBar";
import { setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";

const MORTGAGE_APPLICATION_PROPERTY = "currentlyBrokerInNS";

export const ApplicantCurrentlyBrokerInNS = (props) => {
  const dispatch = useDispatch();

  const agentApplication = useSelector(currentAgentApplicationSelector);

  const handleNext = (currentlyBrokerInNS) => {
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: currentlyBrokerInNS
      })
    );

    //Reset if any for No selectio
    if(!currentlyBrokerInNS && agentApplication?.businessLicenceData?.brokerLicenceNumber) {
      dispatch(setCurrentAgentMortgageProperty({
        key: "brokerLicenceNumber",
        value: ""
      }))
    }

    const nextPath = currentlyBrokerInNS
      ? ROUTE_PATH.MRA_CURRENT_APPLICANT_LICENCE_NUMBER
      : ROUTE_PATH.MRA_IS_CANADA_RESIDENT;

    //NEXT path: MRA_IS_CANADA_RESIDENT

    dispatch(
      push({
        pathname: `${ROUTE_PATH.MRA_APP}${nextPath}`
      })
    );
  };

  return (
    <div className="container">
      {/* Title */}
      <TopNavigationBar {...props} />
      <div className="row">
        <div className="col-xs-12 col-lg-11">
          <Header
            id="broker-next-steps-header"
            header="Is the applicant currently a Mortgage Broker or Associate Mortgage Broker in the Province of Nova Scotia?"
          />
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-8">
          <div className="col-xs-2 ">
            <Button
              className={"btn btn-primary btn-lg"}
              buttonType={"regular_primary"}
              text={"Yes"}
              onClick={() => {
                handleNext(true);
              }}
            />
          </div>

          <div className="col-xs-3">
            <Button
              className={"btn btn-primary btn-lg" /*btn btn-primary ns-btn-yes-no*/}
              buttonType={"regular_primary"}
              text={"No"}
              onClick={() => {
                handleNext(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
